import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Siddharth Bisht',
    title: "Full Stack Developer",
    desciption:"My name is Siddharth Bisht, and I am not just a developer; I am the architect of possibilities. With each line of code I write, I weave a digital tapestry, transforming ideas into reality. Through innovation and determination, I shape the future one algorithm at a time.",
    image: './sid-professional.png',
    resumePdf: resume
}
